/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';
import { TextField } from '@material-ui/core';
import { NumericFormat } from 'react-number-format';
import { useConfiguration } from '../../../redux/features/configuration/useConfiguration';
import { ConfigResourceProps } from '../../../redux/enums/ConfigResourceProps';

const formatValue = (input) => {
  const _value = input?.replace(/\s/g, '').replace(/,/g, '.');
  return parseFloat(_value).toFixed(2);
};

export default function AmountInputWidget({ errors, onChange, value, registry, ...props }) {
  const [_value, setValue] = useState(value);
  const frontendCustomisationConfig = useConfiguration(ConfigResourceProps.FRONTEND_CUSTOMISATION);
  const currencyOptions = frontendCustomisationConfig?.resource?.currency;

  const handleOnChange = (event) => {
    const input = event.target.value;
    setValue(input);
    onChange(formatValue(input));
  };

  const handleBlur = (event) => {
    const input = event.target.value;
    setValue(input);
    onChange(formatValue(input));
    registry.triggerPostProcess(props.id, parseFloat(formatValue(input)));
  };

  return (
    <NumericFormat
      {...props}
      value={_value}
      customInput={TextField}
      data-testid="amount-input"
      onBlur={handleBlur}
      onChange={handleOnChange}
      decimalSeparator={currencyOptions?.decimalSeparator || ','}
      allowLeadingZeros={currencyOptions?.decimalSeparator || true}
      thousandSeparator={currencyOptions?.thousandSeparator || ' '}
    />
  );
}
